/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_GeneralInputs */

const cs_enum_general = /** @type {(inputs: Enum_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecné`)
};

const en_enum_general = /** @type {(inputs: Enum_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {Enum_GeneralInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_general = /** @type {((inputs?: Enum_GeneralInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_GeneralInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_general(inputs)
	return cs_enum_general(inputs)
});